import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { PendingStatusIndicator } from '../../../components/pending-status-indicator'

interface Props {
  readonly created?: string
}
function Wrapper({ created }: Props) {
  return created ? <PendingStatusIndicator created={created} /> : null
}

export const reactPendingStatusIndicator = createNgReactBridgeDirective(
  'reactPendingStatusIndicator',
  [],
  Wrapper,
  []
)
